import { css } from "@emotion/css";
import { type Properties } from "signlets";

import { classes } from "./classes";
import { Overlay } from "./Overlay";

const style = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;

  > .content {
    position: relative;
    margin: 6rem auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    background: #000a;
    border-radius: 0.5rem;
  }
`;

export type ModalProps = {
  visible: boolean;
  class?: string;
  children?: JSX.Element;
};

export const Modal = ({
  visible,
  class: _class,
  children,
}: Properties<ModalProps>) => (
  <Overlay class={style} visible={visible}>
    <div class={classes("content", _class)}>{children}</div>
  </Overlay>
);
